export enum Step {
    Details = 'details',
    Document = 'document',
    Selfie = 'selfie',
}
